export class TradeBlotterFilter {
  constructor() {
    this.id = ''
    this.trade_date_start = ''
    this.trade_date_end = ''
    this.value_date_start = ''
    this.value_date_end = ''
    this.search = ''
    this.deal_status = {
      is_amended: false,
      is_delete: false,
      is_new: false
    }
    this.order = ''
    this.column_order = ''
    this.status_warning_and_union = false
    this.client_quantity = ''
    this.client_price = ''
    this.far_value_date = ''
    this.far_price = ''
    this.far_leg_quantity = ''
    this.market_maker_quantity = ''
    this.market_maker_price = ''
    this.lower_barrier = ''
    this.barrier = ''
    this.upper_barrier = ''
    this.premium = ''
    this.premium_date = ''
    this.fixing_date = ''
    this.window_start = ''
    this.window_end = ''
    this.expiry = ''
    this.types = []
    this.symbols = []
    this.barrier_directions = []
    this.clients = []
    this.market_makers = []
    this.makor_prime_broker = []
    this.option_exercise_style = []
    this.payout_currency = []
    this.premium_currency = []
    this.fixing_source = []
    this.timing = []
    this.traders = []
    this.origin = []
    this.deal_offset = 0
    this.trade_offset = 0
  }
}
